<div class="page-layout" [class.dashboard-layout]="router.url.includes('/' + ROUTES.ACCOUNT.ROOT)">
  <!-- HEADER -->
  <!-- ngSkipHydration: the prerendered/SSR markup is always the signed-out header (auth state
       only exists in the browser, once APP_INITIALIZER has rebuilt it from the /me cookie call).
       Hydrating a signed-in render against that signed-out DOM left both branches in the page
       (duplicate "Price List", a stale "Sign In" button), so render the shell client-side. -->
  <app-header class="header" ngSkipHydration />
  <!-- HEADER -->
  <!-- BODY -->
  <div class="content">
    <router-outlet></router-outlet>
  </div>
  <!-- BODY -->
  <!-- FLOORING/WALLING BANNER SECTION -->
  @if(showBanner) {
  <app-flooring-walling-banner-section />
  }
  <!-- FLOORING/WALLING BANNER SECTION -->
  <!-- FOOTER -->
  <app-footer class="footer" ngSkipHydration />
  <!-- FOOTER -->
  <!-- AI CHAT SUPPORT WIDGET -->
  <!-- ngSkipHydration for the same reason as the header: the widget only renders for signed-in
       users, and auth state exists in the browser only, so the prerendered markup is always empty.
       Suppressed on the Ask Pebbl page - the chat already fills the window there. -->
  @if (!router.url.includes('/' + ROUTES.ASK_PEBBL)) {
  <app-ai-chat ngSkipHydration />
  }
  <!-- AI CHAT SUPPORT WIDGET -->
</div>